import { Route } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { RoleGuard } from '../guards/role.guard';

export const usersRoutes: Route[] = [
  {
    path: 'users-accounts/users-requests',
    loadComponent: () =>
      import('../../features/users/pages/users-requests/users-requests').then(
        (mod) => mod.UsersRequests
      ),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'users-accounts/users-list',
    loadComponent: () =>
      import('../../features/users/pages/users-list/users-list').then(
        (mod) => mod.UsersList
      ),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'users-accounts/:userId/user-details',
    loadComponent: () =>
      import('../../features/users/pages/user-details/user-details').then(
        (mod) => mod.UserDetails
      ),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
];
